import { createApi } from '@logistech/ui-shared';

import { sessionStorage } from './storage';

import { useAuth } from '@/store/auth';

const API_BASE = import.meta.env.VITE_API_URL ?? 'http://localhost:3000';

export const api = createApi({
  baseUrl: API_BASE,
  storage: sessionStorage,
  onUnauthorized: () => {
    window.location.href = '/login';
  },
  // Le store est la source des permissions affichées (menu, boutons, badge de rôle)
  onSessionRefreshed: (session) => useAuth.setState({ session }),
});
